import React from 'react';
import { render } from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import 'font-awesome/css/font-awesome.css';

import App from './components/App';
import client from './apollo-client';
import store from './common/store';
import './styles/coreui/style.scss';

render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js